import { Button } from "./ui/button";
import { RefreshCw, X } from "lucide-react";
import { useServiceWorkerUpdate } from "../hooks/useServiceWorkerUpdate";
import { useState } from "react";

export default function UpdatePrompt() {
  const { updateAvailable, skipWaiting } = useServiceWorkerUpdate();
  const [dismissed, setDismissed] = useState(false);

  if (!updateAvailable || dismissed) return null;

  return (
    // `bottom` carries the home-indicator inset: this is `fixed` to the
    // bottom edge, so on a notched phone "Restart now" lands in the strip the
    // OS owns. 0px on desktop.
    <div className="fixed bottom-[calc(1rem+var(--safe-area-bottom))] right-4 bg-white border border-callisto rounded-lg shadow-lg p-4 max-w-sm z-50" data-testid="update-prompt">
      <div className="flex items-start gap-3">
        <RefreshCw size={18} className="text-callisto-navy mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-callisto-navy">App update available</p>
          <p className="text-xs text-callisto-muted mt-1">Restart to get the latest features and improvements.</p>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="text-callisto-muted hover:text-callisto-navy shrink-0 mt-0.5"
          aria-label="Dismiss"
        >
          <X size={16} />
        </button>
      </div>
      <div className="flex gap-2 mt-3">
        <Button
          variant="outline"
          size="sm"
          onClick={() => setDismissed(true)}
          className="h-8 border-callisto text-xs"
        >
          Later
        </Button>
        <Button
          size="sm"
          onClick={skipWaiting}
          className="h-8 bg-callisto-navy hover:bg-callisto-navy/90 text-white text-xs"
          data-testid="update-prompt-restart"
        >
          Restart now
        </Button>
      </div>
    </div>
  );
}
